//controllers/flatpickr_controller.js
//import stimulus-flatpickr wrapper controller to extend it
import Flatpickr from 'stimulus-flatpickr';

//you can also import a translation file
import { Korean } from 'flatpickr/dist/l10n/ko';

//import a theme (could be in your main CSS entry too...)
import 'flatpickr/dist/flatpickr.css';

//create a new Stimulus controller by extending stimulus-flatpickr wrapper controller
export default class extends Flatpickr {
  static values = {
    enable: true,
  }

  initialize() {
    if(this.enableValue){
      this.config = {
        locale: Korean,
      };
      return;
    }
    this.element.readonly = true;
    this.element.classList.add('!text-gray-500');
    this.element.classList.add('!bg-gray-200');
    this.config = {
      locale: Korean,
      enableTime: false,
      enable: [],
    };
  }
}
